<section class="login-shell">
  <div class="login-panel">
    <div class="login-brand">
      <div class="brand-icon" aria-hidden="true"><span class="material-icons">lock_reset</span></div>
      <h1>Intranet</h1>
    </div>
    <div class="login-card">
      <h2>Cambiar contraseña</h2>
      <p class="change-intro">Para continuar, establece una nueva contraseña para tu cuenta.</p>
      <form class="login-form" (ngSubmit)="submit()" #passwordForm="ngForm">
        <div class="login-field">
          <label for="currentPassword">Contraseña actual</label>
          <div class="input-wrap"><input id="currentPassword" name="currentPassword" type="password" autocomplete="current-password" [(ngModel)]="currentPassword" required></div>
        </div>
        <div class="login-field">
          <label for="newPassword">Nueva contraseña</label>
          <div class="input-wrap"><input id="newPassword" name="newPassword" type="password" autocomplete="new-password" [(ngModel)]="newPassword" minlength="8" required></div>
          <small>Mínimo 8 caracteres.</small>
        </div>
        <div class="login-field">
          <label for="confirmation">Repetir nueva contraseña</label>
          <div class="input-wrap"><input id="confirmation" name="confirmation" type="password" autocomplete="new-password" [(ngModel)]="confirmation" required></div>
        </div>
        <div *ngIf="errorMessage" class="login-error" role="alert">{{ errorMessage }}</div>
        <button class="login-submit" type="submit" [disabled]="passwordForm.invalid || saving">{{ saving ? 'Guardando...' : 'Guardar contraseña' }}</button>
        <button class="change-cancel" type="button" (click)="cancel()">Cerrar sesión</button>
      </form>
    </div>
    <div class="login-logo"><img src="assets/footer.png" alt="Healthfinder"></div>
  </div>
</section>
